<template>
  <div class="section">
    <div class="container" style="margin-top: -30px;">
      
      <b-field>
        <img :src="imageSrc1" alt="" />
      </b-field>

      <b-field>
        <img :src="imageSrc2" alt="" />
      </b-field>

      <b-field style="margin-top: -250px;">
        <img :src="imageSrc3" alt="" />
      </b-field>
      
     
      

      

      

      
      
     

     
      
    </div>  
  </div>
</template>

<script>
export default {
  name: "home",  
  
  data() {
    return {

    };
  },
  method: {
    
  },
  mounted() {
   
  },
  computed: {   
    // Using pathify

    imageSrc1() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/news02/news02-01.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/news02/news02-01.png';
    },

    imageSrc2() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/news02/news02-02.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/news02/news02-02.png';
    },

    imageSrc3() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/news02/news02-03.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/news02/news02-03.png';
    },

   
    lang() {
     
      return this.$store.get('switchLang') || 1;
    },
  },
};
</script>

<style scoped>
.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}
</style>
